import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FormattedMessage } from 'react-intl';
import FolderOffIcon from '@mui/icons-material/FolderOff';

const EmptyTable = ({ messageId }: { messageId: string }) => (
    <Box
        sx={{
            minWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            mt: 3
        }}
    >
        <FolderOffIcon sx={{ width: 50, height: 50, opacity: 0.5 }} />
        <Typography variant="h3" sx={{ mt: 2 }}>
            <FormattedMessage id={messageId} />
        </Typography>
    </Box>
);

export default EmptyTable;
